import { CurrencyCode, Money } from '../model/models';

export const subtractMoney = (minuend: Money, subtrahend: Money): Money => ({
    cents: minuend.cents - subtrahend.cents,
    currencyCode: subtrahend.currencyCode
});

export const multiplyMoney = (money: Money, by: number): Money => ({
    cents: money.cents * by,
    currencyCode: money.currencyCode
});

export const sumMonies = (monies: Money[]): Money =>
    monies.reduce(
        (prev, curr) => ({
            cents: (prev.cents || 0) + curr.cents,
            currencyCode: curr.currencyCode
        }),
        { cents: 0, currencyCode: CurrencyCode.UNKNOWN_CURRENCY_CODE }
    );
